(()=>{
if(window.__clhModeAnalytics)return;
window.__clhModeAnalytics=true;
const id='G-6MJ2MM0DSB',root=document.documentElement;
if(window.Shopify?.designMode||window.Shopify?.previewMode||new URLSearchParams(location.search).has('preview_theme_id'))return;
let ready=false,lastMode=null,viewSent=false;
const mode=()=>root.dataset.clhMode==='classic'?'classic':'modern';
const allowed=()=>window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()===true;
function gtag(){window.clhModeDataLayer=window.clhModeDataLayer||[];window.clhModeDataLayer.push(arguments)}
function start(){
if(!allowed())return;
if(!ready){
ready=true;
gtag('consent','default',{analytics_storage:'granted',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
gtag('js',new Date());
gtag('config',id,{send_page_view:false,allow_google_signals:false,allow_ad_personalization_signals:false,page_location:location.origin+location.pathname});
const script=document.createElement('script');script.async=true;script.src='https://www.googletagmanager.com/gtag/js?id='+id+'&l=clhModeDataLayer';document.head.append(script);
}
if(!viewSent){viewSent=true;lastMode=mode();send('clh_mode_view',lastMode)}
}
function send(name,current,previous){
if(!allowed()||!ready)return;
const params={send_to:id,display_mode:current,page_location:location.origin+location.pathname};
if(previous)params.previous_mode=previous;
gtag('event',name,params);
}
new MutationObserver(()=>{
const current=mode();
if(current===lastMode)return;
const previous=lastMode;lastMode=current;
if(previous&&viewSent&&allowed()){
send('clh_mode_switch',current,previous);
send('clh_mode_view',current,previous);
}
}).observe(root,{attributes:true,attributeFilter:['data-clh-mode']});
document.addEventListener('visitorConsentCollected',start);
if(window.Shopify?.customerPrivacy)start();
else if(window.Shopify?.loadFeatures)window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)start()});
})();